module.exports = __webpack_public_path__ + "img/auto_gradient.a1af94ec.png";